import React, { useState, memo } from "react";
import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Text } from "../Base";
import { View } from "../View";
import { WarningIcon } from "../Icons/Warning";
import { palette } from "../../theme/palette";
import { OverridePopup } from "./OverridePopup";

const useStyles = makeStyles({
  markerContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "-18px",
    marginLeft: "2px",
    cursor: "pointer",
  },
  container: {
    width: "30px",
    height: "30px",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
    padding: "2px",
  },
  textContainer: {
    background: palette.black,
    borderRadius: "4px",
  },
  text: {
    margin: "auto",
  },
  conflictIconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: palette.dpdRed,
    borderRadius: "4px",
  },
  conflictIcon: {
    width: "18px",
    height: "18px",
    fill: palette.typography.white.high,
  },
  spacing: {
    padding: "2px",
  },
  icon: {
    height: "10px",
    width: "10px",
  },
  overrideCountContainer: {
    height: "16px",
    width: "16px",
    borderRadius: "100px",
    background: palette.white,
    position: "relative",
    right: "8px",
    top: "12px",
    boxShadow: `-1px 1px 2px 0px ${palette.typography.black.high}`,
  },
  overrideCountText: {
    fontSize: "10px",
    margin: "auto",
  },
});

export const OverrideLabel = memo(({ routeEdit, routes, overrides }) => {
  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState();

  const hasConflicts = overrides.some(({ conflict }) => conflict);
  const hasOverrideForRouteEdit =
    routeEdit &&
    !hasConflicts &&
    overrides.some(({ routeCode }) => routeCode === routeEdit.routeCode);

  const overrideCount = !hasOverrideForRouteEdit
    ? overrides.length
    : overrides.filter(({ routeCode }) => routeCode === routeEdit.routeCode)
        .length;
  const isMultipleRoutesPresent = !!overrides.some(
    ({ routeCode }) => routeCode !== overrides[0].routeCode
  );

  let textContainerStyle, textStyle;
  if (hasOverrideForRouteEdit) {
    textStyle = {
      color: routeEdit.textColour,
    };
    textContainerStyle = {
      background: routeEdit.colour,
    };
  } else if (isMultipleRoutesPresent || routeEdit) {
    textStyle = {
      color: "white",
    };
    textContainerStyle = {
      background: "black",
    };
  } else if (routes) {
    const overrideRoute = routes[overrides[0].routeCode];
    const colour = overrideRoute?.colour;
    const textColour = overrideRoute?.textColour;
    textStyle = {
      color: textColour,
    };
    textContainerStyle = {
      background: colour,
    };
  }

  return (
    <>
      <View className={styles.markerContainer}>
        <View>
          <Grid
            container
            className={styles.overrideCountContainer}
            style={{
              visibility:
                overrideCount > 1 || hasOverrideForRouteEdit
                  ? "visible"
                  : "hidden",
            }}
          >
            <Text className={styles.overrideCountText}>{overrideCount}</Text>
          </Grid>
          <Grid
            container
            className={styles.container}
            onClick={(e) => {
              e.stopPropagation();
              setAnchorEl(!anchorEl ? e.currentTarget : null);
            }}
            role="button"
            aria-pressed={!!anchorEl}
          >
            {!hasConflicts ? (
              <Grid
                container
                className={styles.textContainer}
                style={{ ...textContainerStyle }}
              >
                <Text className={styles.text} style={{ ...textStyle }}>
                  O
                </Text>
              </Grid>
            ) : (
              <Grid container className={styles.conflictIconContainer}>
                <WarningIcon className={styles.conflictIcon} />
              </Grid>
            )}
          </Grid>
        </View>
        <OverridePopup
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          overrides={overrides}
        />
      </View>
    </>
  );
});
